import React from "react";
import { useParams } from "react-router-dom";
import ScormFileExplorer from "./ScormFileExplorer";

const ScormFileExplorerWrapper = () => {
  const { scormId } = useParams();
  return <ScormFileExplorer scormId={scormId} />;
};

export default ScormFileExplorerWrapper; 